import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiModule } from '../../../../ui/ui.module';

import { RegistrationProductInformationComponent } from './registration-product-information.component';

@NgModule({
	imports: [
		CommonModule,
		UiModule,
	],
	declarations: [RegistrationProductInformationComponent],
	exports: [RegistrationProductInformationComponent],
})
export class RegistrationProductInformationModule {

}
